import INVENTORY_API_BASE_URL from "../../config/api";
import "./Booksupplier.css";
import { useState } from "react";
import Axios from "axios";
import swal from "sweetalert";

function Booksupplier() {
  const [listOfBooks, setlistOfBooks] = useState([]);
  const [Booksupplier, setBooksupplier] = useState("");
  const [Mob, setMob] = useState("");
  const [Whatsapp, setWhatsapp] = useState("");
  const [Email, setEmail] = useState("");
  const [Address, setAddress] = useState("");
  const [GSTNumber, setGSTNumber] = useState("");
  const [Alternatenumber, setAlternatenumber] = useState("");
  const [Bankname, setBankname] = useState("");
  const [Accountnumber, setAccountnumber] = useState("");
  const [Ifsccode, setIfsccode] = useState("");
  const [Pancard, setPancard] = useState("");


  const createUser = () => {
    if (!validateForm()) {
      swal("Please fill all the input fields.", "", "error");
      return;
    }

    Axios.post(`${INVENTORY_API_BASE_URL}/postBooksupplier`, {
      Booksupplier,
      Mob,
      Whatsapp,
      Email,
      Address,
      GSTNumber,
      Alternatenumber,
      Bankname,
      Accountnumber,
      Ifsccode,
      Pancard,
    }).then(() => {
      setlistOfBooks([
        ...listOfBooks,
        {
          Booksupplier,
          Mob,
          Whatsapp,
          Email,
          Address,
          GSTNumber,
          Alternatenumber,
          Bankname,
          Accountnumber,
          Ifsccode,
          Pancard,
        },
      ]);
      swal({
        title: "Book Supplier Created",
        text: "",
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    });
  };


  const validateForm = () => {
    return Booksupplier !== "";
  };

  return (
    <div className="Maindiv">
      <form className="booksupplierform">
        <h5 className="booksupplier"> Create Book Supplier </h5>
        <h5 className="booksuppliername">
          Book Supplier Name:
          <span
            style={{
              color: "red",
              fontSize: "50%",
              position: "relative",
              top: "-0.8em",
            }}
          >
            &#9733;
          </span>{" "}
        </h5>
        <input
          className="suppliername"
          type="text"
          name="BookSupplierName"
          required="required"
          onChange={(event) => {
            setBooksupplier(event.target.value);
          }}
        />

        <h5 className="booksuppliername">Mob:</h5>
        <input
          className="suppliername1"
          type="text"
          name="Mob"
          onChange={(event) => {
            setMob(event.target.value);
          }}
        />

        <h5 className="booksuppliername">Alternate Number:</h5>
        <input
          className="supplierMob"
          type="text"
          name="Alternatenumber"
          onChange={(event) => {
            setAlternatenumber(event.target.value);
          }}
        />

        <h5 className="booksuppliername">Whatsapp:</h5>
        <input
          className="supplierwhatsapp"
          type="text"
          name="Whatsapp"
          onChange={(event) => {
            setWhatsapp(event.target.value);
          }}
        />

        <h5 className="booksuppliername">Email:</h5>
        <input
          className="supplieremail"
          type="text"
          name="Email"
          onChange={(event) => {
            setEmail(event.target.value);
          }}
        />

        <h5 className="booksuppliername">Address:</h5>
        <input
          className="supplieraddress"
          type="text"
          name="Address"
          onChange={(event) => {
            setAddress(event.target.value);
          }}
        />

        <h5 className="booksuppliername">GSTNumber</h5>
        <input
          className="supplierGST"
          type="text"
          name="GSTNumber"
          onChange={(event) => {
            setGSTNumber(event.target.value);
          }}
        />

        <h5 className="booksuppliername">Pan Card</h5>
        <input
          className="supplierPan"
          type="text"
          name="Pancard"
          onChange={(event) => {
            setPancard(event.target.value);
          }}
        />

        <h5 className="booksuppliername">Bank Name</h5>
        <input
          className="supplierbank"
          type="text"
          name="Bankname"
          onChange={(event) => {
            setBankname(event.target.value);
          }}
        />

        <h5 className="booksuppliername">Account Number </h5>
        <input
          className="supplierAccount"
          type="text"
          name="Accountnumber"
          onChange={(event) => {
            setAccountnumber(event.target.value);
          }}
        />

        <h5 className="booksuppliername">IFSC Code </h5>
        <input
          className="supplierIFSC"
          type="text"
          name="Ifsccode"
          onChange={(event) => {
            setIfsccode(event.target.value);
          }}
        />

        <button className="btmf" type="submit" onClick={createUser}>
          Save
        </button>
      </form>
    </div>
  );
}

export default Booksupplier;
